var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('market-form',{attrs:{"marketFormInfo":_vm.marketFormInfo,"marketFormFieldList":_vm.marketFormFieldList},on:{"handleSubmit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }